import { P5Sketch } from "../interfaces/P5Sketch.interface";

const SketchCatalog: Array<P5Sketch> = [];

export default SketchCatalog;
